var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70222 9.2686H13.2013V11.0115C13.7053 10.0091 14.9979 9.10844 16.9397 9.10844C20.662 9.10844 21.5458 11.1039 21.5458 14.765V21.5455H17.7772V15.5988C17.7772 13.5138 17.2732 12.3381 15.99 12.3381C14.2103 12.3381 13.4707 13.6052 13.4707 15.5978V21.5455H9.70222V9.2686ZM3.24014 21.3854H7.00867V9.10844H3.24014V21.3854ZM7.54851 5.10532C7.54865 5.42119 7.486 5.73394 7.36422 6.02539C7.24243 6.31684 7.06393 6.58118 6.83908 6.80304C6.38347 7.25585 5.76676 7.50931 5.1244 7.50775C4.48318 7.50732 3.86789 7.25451 3.41161 6.80398C3.18758 6.58137 3.00968 6.31673 2.88811 6.02524C2.76653 5.73376 2.70367 5.42114 2.70312 5.10532C2.70312 4.46749 2.9575 3.85699 3.41255 3.40665C3.86843 2.95552 4.48398 2.7026 5.12535 2.70288C5.76788 2.70288 6.38403 2.95631 6.83908 3.40665C7.29319 3.85699 7.54851 4.46749 7.54851 5.10532Z",
    fill: "#1A2E94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLanding);
export default __webpack_public_path__ + "static/media/linkedin_landing.8feafd9bab0634443c051b964742af98.svg";
export { ForwardRef as ReactComponent };